

let appVersion = "2.12";

export default appVersion;